import React from "react";
import { NewAccordion } from "../NewAccordion";
import {
  Ingredients as IngredientsHeading,
  Nutrient,
  Quantity,
} from "../../../Constants";
import { useTranslation } from "react-i18next";

const Ingredients = ({ ingredients }) => {
  const { t } = useTranslation();
  return (
    <NewAccordion heading={t(IngredientsHeading)} borderBottom={false}>
      <div className="table-responsive">
        <table className="table accordion" id="accordionExample">
          <thead>
            <tr>
              <td className="t-text-[11px] md:t-text-sm t-w-[35%] md:t-w-[40%] t-font-bold">
                {t(Nutrient)}
              </td>
              <td className="t-text-[11px] md:t-text-sm t-text-center t-font-bold">
                {t(Quantity)}
              </td>
              <td className="t-text-[11px] md:t-text-sm !t-text-center t-font-bold">
                %NRV
              </td>
            </tr>
          </thead>
          <tbody>
            {ingredients?.map((item) => (
              <tr className="t-relative ">
                <td className="t-text-[11px] md:t-text-sm t-w-[35%] md:t-w-[40%] t-font-bold">
                  {item?.name}
                </td>
                <td className="t-text-[11px] md:t-text-sm t-text-center t-font-bold">
                  {item?.quantity}mg
                </td>
                <td className="t-text-[11px] md:t-text-sm !t-text-center t-font-bold">
                  {item?.nrv === "0" ? "*" : item?.nrv + "%"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </NewAccordion>
  );
};

export default Ingredients;
